import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { API } from "../lib/api";
import useSeo from "../hooks/useSeo";
import JobCard from "../components/JobCard";
import HomeHero from "../components/home/HomeHero";
import RolesTicker from "../components/home/RolesTicker";
import CategoryGrid from "../components/home/CategoryGrid";
import StateFinder from "../components/home/StateFinder";
import HowItWorks from "../components/home/HowItWorks";
import FaqSection from "../components/home/FaqSection";
import FinalCta from "../components/home/FinalCta";

export default function Home() {
  const location = useLocation();
  const [cats, setCats] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [total, setTotal] = useState(0);

  useSeo({
    title: "Direct Hire Team · Remote Jobs in All 50 States — Free for Job Seekers",
    description: "Skip the job-board black hole. Get matched by a real recruiter to remote jobs in payroll, finance, HR, IT, marketing, sales, legal, admin and more — in all 50 states. Free, 30-second application.",
    url: "https://directhireteam.com/",
  });

  useEffect(() => {
    fetch(`${API}/categories`).then((r) => r.json()).then((d) => setCats(d.categories || [])).catch(() => {});
    fetch(`${API}/jobs?limit=12`).then((r) => { setTotal(Number(r.headers.get("X-Total-Count")) || 0); return r.json(); }).then((rows) => setFeatured(rows || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (location.state?.focusMatch) setTimeout(() => document.getElementById("quick-match")?.scrollIntoView({ behavior: "smooth" }), 150);
  }, [location.state]);

  const catLabel = (k) => cats.find((c) => c.key === k)?.label;

  return (
    <div className="bg-[#FAF7EE] min-h-screen" data-testid="home-page">
      <HomeHero cats={cats} total={total} />
      <RolesTicker jobs={featured} total={total} catCount={cats.length} />
      <CategoryGrid cats={cats} />
      <section className="py-16 md:py-24" data-testid="home-featured-jobs">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <div className="text-[11px] tracking-[0.25em] uppercase text-[#0d7a55] font-bold">Fresh this week</div>
          <div className="mt-3 flex items-end justify-between flex-wrap gap-4">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F2A1F] leading-tight max-w-2xl">Roles employers want filled — fast.</h2>
            <Link to="/jobs" className="text-[#0F2A1F] font-semibold hover:underline inline-flex items-center gap-1.5" data-testid="featured-see-all">View all {total > 0 ? total : ""} jobs <ArrowRight className="h-4 w-4" /></Link>
          </div>
          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {featured.slice(0, 6).map((j) => (
              <JobCard key={j.id} job={j} catLabel={catLabel(j.category)} cardTestId={`featured-job-${j.id}`} applyTestId={`apply-featured-${j.id}`} />
            ))}
          </div>
        </div>
      </section>
      <StateFinder />
      <HowItWorks />
      <FaqSection />
      <FinalCta />
    </div>
  );
}
